
// Legal.js

import React from 'react';

import TextField from '../text/TextField';
import TitleField from '../text/TitleField';

import '../../styles/legalcomponents/LegalHeader.css';

const LegalHeader = ({eyebrow="", title, lastUpdated="", description=""}) => {



    return (
        <>
            <div className='legal-header-container'>

                <div className='legal-titles-container'>
                    {eyebrow &&
                        <TextField
                            className="legal-eyebrow-label"
                            text={eyebrow}
                            bold={true}
                            fontSize='0.8rem'
                            fontColor='#5a7a1a'
                            />
                    }

                    <TitleField
                        title={title}
                        bold={true}
                        fontSize='3.5rem'
                        />

                    {lastUpdated &&
                        <div className='legal-last-updated-container'>

                            <TextField
                                text="Last Updated: "
                                fontSize='1.25rem'
                                bold={true}/>


                            <TextField
                                text={lastUpdated}
                                fontSize='1.25rem'
                                bold={false}
                                />
                        </div>



                    }

                    {description &&
                        <div className='legal-description-container'>
                            <TextField
                                text={description}
                                fontSize='1.05rem'
                                fontColor='#555555'
                                />
                        </div>
                    }
                </div>

                <span className='legal-horizontal-line'/>

            </div>

        </>
    )
}

export default LegalHeader;